import * as actionTypes from './types';

function clearCarrierGuideContent(state, action) {
    const {
        [action.payload]: _toRemove,
        ...nextState
    } = state;

    return nextState;
}

function setCarrierGuideContent(state, action) {
    return {
        ...state,
        [action.meta]: action.payload,
    };
}

const reducerFunctions = {
    [actionTypes.CLEAR_CARRIER_GUIDE_CONTENT]: clearCarrierGuideContent,
    [actionTypes.SET_CARRIER_GUIDE_CONTENT]: setCarrierGuideContent,
};

export default function reducer(state = {}, action) {
    if (!reducerFunctions.hasOwnProperty(action.type)) {
        return state;
    }

    return reducerFunctions[action.type](state, action);
}
